module.exports = __webpack_public_path__ + "br.svg?7118606b76a22d5f3f41b9b43b06a3f6";